import _defineProperty from "@babel/runtime/helpers/defineProperty";
//*****************************************************************************
//*****************************************************************************
//************           THIS COMPONENT IS DEPRECATED              ************
//************         Instead, use Form from ui-forms           ************
//*****************************************************************************
//*****************************************************************************
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactResizeDetector from 'react-resize-detector';
import BaseContainer from './Container';
import { medium, xlarge, xxxlarge } from '../Styles/spacing';
import { smallMax } from '../Styles/breakpoints';
const Container = /*#__PURE__*/styled(BaseContainer).withConfig({
  displayName: "FormContainerDeprecated__Container",
  componentId: "sc-hsi635-0"
})(["max-width:760px;margin-left:auto;margin-right:auto;"]);
const Prefix = /*#__PURE__*/styled(BaseContainer).withConfig({
  displayName: "FormContainerDeprecated__Prefix",
  componentId: "sc-hsi635-1"
})(["padding:0;border-bottom:0;"]);
Prefix.displayName = 'FormContainerPrefix';
const BasicBody = /*#__PURE__*/styled(BaseContainer).withConfig({
  displayName: "FormContainerDeprecated__BasicBody",
  componentId: "sc-hsi635-2"
})(["background:transparent;"]);
BasicBody.displayName = 'FormContainerBasicBody';
const DefaultBody = /*#__PURE__*/styled(BasicBody).withConfig({
  displayName: "FormContainerDeprecated__DefaultBody",
  componentId: "sc-hsi635-3"
})(["padding:", ";"], _ref => {
  let {
    width
  } = _ref;
  return width >= smallMax ? "".concat(xlarge, " ").concat(xxxlarge, ";") : "".concat(medium, " ").concat(xlarge, ";");
});
DefaultBody.displayName = 'FormContainerDefaultBody';
/**
 * @deprecated Please use <Form> instead from ui-forms
 */

export default class FormContainerDeprecated extends React.PureComponent {
  render() {
    console.warn('FormContainer(ui-atoms) IS DEPRECATED. USE Form(ui-forms) INSTEAD.');
    const {
      children: origChildren,
      bodyType: Body,
      ...props
    } = this.props;
    const prefix = [];
    const children = [];

    if (origChildren && Array.isArray(origChildren)) {
      origChildren.forEach(child => {
        if ((child === null || child === void 0 ? void 0 : child.type) === Prefix) {
          prefix.push(child);
        } else {
          children.push(child);
        }
      });
    } else if (origChildren) {
      children.push(origChildren);
    }

    return /*#__PURE__*/React.createElement(Container, props, prefix, /*#__PURE__*/React.createElement(ReactResizeDetector, {
      handleWidth: true
    }, /*#__PURE__*/React.createElement(Body, null, children)));
  }

}

_defineProperty(FormContainerDeprecated, "Prefix", Prefix);

_defineProperty(FormContainerDeprecated, "Body", DefaultBody);

_defineProperty(FormContainerDeprecated, "BasicBody", BasicBody);

_defineProperty(FormContainerDeprecated, "propTypes", {
  /**
   * How the container should look. "ghost" would have a white
   * background. "light" has a light grey background. "recessed" has
   * light grey background with shadows on top (if its not the first
   * child) and bottom (if its not the last child)
   */
  context: PropTypes.oneOf(['ghost', 'light', 'recessed']),

  /** Content inside the container */
  children: PropTypes.node,

  /** Whether borders should be drawn around the container */
  withBorder: PropTypes.bool,

  /** The Component class/function to wrap the body */
  bodyType: PropTypes.any
});

_defineProperty(FormContainerDeprecated, "defaultProps", {
  context: 'ghost',
  withBorder: true,
  bodyType: FormContainerDeprecated.Body
});